import location from "../../common/ts/core/location";

export function navigateToUserSearchWith(
    host: string,
    newSearchParams: URLSearchParams,
) {
    return new location.AssignUrlEvent({
        url: `${host}/find?${newSearchParams.toString()}`
    })
}